import { fetchEndpoint } from '../server/network'

// 获取优惠活动列表
export const activityList = () => fetchEndpoint('/v2/ecapi.activity.list', 'POST')

// 获取优惠活动列表
export const activityDetail = (data) => fetchEndpoint('/v2/ecapi.activity.get', 'POST', data)

//展会
export const exhibition = (data) => fetchEndpoint('/v2/ecapi.exhibit.get', 'POST', data)
	
//展会详情
export const exhibit = (data) => fetchEndpoint('/v2/ecapi.exhibit.particulars', 'POST', data)

//校园行
export const campusTour = (data) => fetchEndpoint('/v2/ecapi.campustour.get', 'POST', data)


// WEBPACK FOOTER //
// ./src/api/activity.js